import React, { useEffect, useState } from 'react'
import ReactPaginate from 'react-paginate'
import NodataYet from '../../../../Components/NodataYet'
import Select from 'react-select'
import { useNavigate } from 'react-router-dom'
import { useDispatch, useSelector } from 'react-redux'
import {
  getAllUserDetails,
} from '../Overview/OverviewSlice/UserDetailsSlice'
import { KTSVG } from '../../../../../_metronic/helpers'
import moment from 'moment-timezone'
import { useLazyGetSubClientSimpleQuery } from '../../../../../services/cellcast.v2'
import { AuthenticateUser } from '../../../../Utils/_helpers/RoleAndPermission'
import DatePicker from 'react-datepicker'
import { useLazyGetCreditTransactionExportDataQuery } from '../../../../../services/cellcast'
import { ENV } from '../../../../Utils/_helpers/EnvHelper'
import { Spinner } from 'react-bootstrap'
import { useBalanceHistory } from './useBalanceHistory'

const CreditHistoryTable = () => {
  const { fetchBalanceHistory, userCreditHistory } = useBalanceHistory();

  const userData: any = useSelector(getAllUserDetails)
  const API_DOMAIN = ENV().REACT_APP_DOMAIN

  const [dateRange, setDateRange] = useState<any>(['', ''])
  const [startDate, endDate] = dateRange

  const navigate = useNavigate()

  const [page, setPage] = useState({
    page: 1,
    size: 10,
    type: { value: '', label: 'Select type' },
    campType: { value: '', label: 'Select transaction ' },
    addedBy: { value: '', label: 'Select user' },
  })
  const [isShowCredit, setIsShowCredit] = useState(true)
  const [fetchSubClientAccount, { data: subClients, isLoading: subClientLoading }] =
    useLazyGetSubClientSimpleQuery()

  const [getCreditTransactionExport, { isFetching: isLoadingExport }] =
    useLazyGetCreditTransactionExportDataQuery()

  useEffect(() => {
    fetchCreditHistory({ page, userData, dateRange })
  }, [page, userData, dateRange])

  const fetchCreditHistory = ({ page, userData, dateRange }: any) => {
    let isAsOwner = true
    if (userData.subClientAccountId && userData.subClientAccountId !== '') {
      if (userData._id !== userData.ownerId) {
        isAsOwner = false
      }
    }
    const data = {
      page: page.page,
      size: page.size,
      type: page.type?.value,
      campType: page.campType?.value,
      isAsOwner: isAsOwner ? 'true' : 'false',
      addedBy: page.addedBy?.value,
      fromDate: '',
      toDate: '',
    }

    if (startDate && endDate) {
      data.fromDate = moment(startDate).format('YYYY-MM-DD')
      data.toDate = moment(endDate).format('YYYY-MM-DD')
    }

    fetchBalanceHistory(data)
  }

  useEffect(() => {
    if (userData.subClientAccountId && userData.subClientAccountId !== '') {
      if (userData._id !== userData.ownerId) {
        setIsShowCredit(false)
      }
    }

    if (userData && userData.isSubClientAccount === true) {
      fetchSubClientAccount(null)
    }
  }, [userData])

  const exportData = () => {
    let isAsOwner = true

    if (userData.subClientAccountId && userData.subClientAccountId !== '') {
      if (userData._id !== userData.ownerId) {
        isAsOwner = false
      }
    }

    const data = {
      isAsOwner: isAsOwner ? 'true' : 'false',
      addedBy: page.addedBy?.value,
      type: page.type?.value,
      fromDate: '',
      toDate: '',
      campType: page.campType?.value,
    }

    if (startDate && endDate) {
      data.fromDate = moment(startDate).format('YYYY-MM-DD')
      data.toDate = moment(endDate).format('YYYY-MM-DD')
    }

    getCreditTransactionExport(data)
      .unwrap()
      .then((res) => {
        window.open(`${API_DOMAIN}${res.data.downloadurl}`, '_self')
      })
  }

  return (
    <div className='card'>
      <div className='card-header border-0 py-5 px-8'>
        <h3 className='card-title align-items-start flex-column'>
          <span className='card-label fw-bolder fs-2 mb-1'>Credit History</span>
          <span className='text-muted mt-1 fw-bold fs-7'>Ordered by the most recent</span>
        </h3>

        <div className='card-toolbar'>
          <div className='d-flex' data-testid='datePickerCreditHistory'>
            <DatePicker
              selectsRange={true}
              dateFormat='MMM d, yyyy'
              className=' border-0 form-control form-control-lg form-control-solid'
              placeholderText='Pick data & time'
              onChange={(update: any) => {
                setDateRange(update)
              }}
              startDate={startDate}
              endDate={endDate}
            />
            <span
              className='input-group-text'
              style={{ backgroundColor: '#f5f8fa', borderRadius: 0, borderColor: '#f5f8fa' }}
            >
              <i className='bi bi-calendar'></i>
            </span>
          </div>

          <button
            data-testid='btnFilterCreditHistory'
            className={`position-relative btn btn-light-primary ms-3 me-3 filter_btn `}
            data-kt-menu-trigger='hover'
            data-kt-menu-placement='bottom-end'
            data-kt-menu-flip='top-end'
          >
            <KTSVG path='/media/icons/duotune/general/gen031.svg' className='svg-icon-2' />
            Filter
          </button>

          <div
            className={`position-absolute menu menu-sub menu-sub-dropdown w-250px w-md-300px `}
            data-kt-menu='true'
          >
            <div className='px-7 py-5'>
              <div className='mb-10'>
                <label className='form-label fw-bold'>Transaction:</label>
                <Select
                  placeholder='Select transaction'
                  value={page?.type}
                  options={[
                    { value: '', label: 'Select transaction ' },
                    { value: 'credit', label: 'Credited' },
                    { value: 'debit', label: 'Debit' },
                  ]}
                  onChange={(e: any) => setPage({ ...page, type: e, page: 1, size: 10 })}
                />
              </div>

              <div className='mb-10'>
                <label className='form-label fw-bold'>Type:</label>
                <Select
                  placeholder='Select type'
                  value={page?.campType}
                  options={[
                    { value: '', label: 'Select type ' },
                    { value: 'sms', label: 'SMS' },
                    { value: 'mms', label: 'MMS' },
                  ]}
                  onChange={(e: any) => setPage({ ...page, campType: e, page: 1, size: 10 })}
                />
              </div>
              {userData && userData.isSubClientAccount === true && (
                <div className='mb-10'>
                  <label className='form-label fw-bold'>Sub Client:</label>
                  <Select
                    placeholder='Select sub client'
                    value={page?.addedBy}
                    options={
                      subClients && subClients.data && subClients.data.length > 0
                        ? [
                          { value: '', label: 'Select user' },
                          ...subClients.data.map((el) => ({
                            value: el._id,
                            label: el.name,
                          })),
                        ]
                        : [{ value: '', label: 'Select user' }]
                    }
                    onChange={(e: any) => setPage({ ...page, addedBy: e, page: 1, size: 10 })}
                  />
                </div>
              )}
            </div>
          </div>
          {AuthenticateUser('purchase-credits') && isShowCredit && (
            <button data-testid='btnBuyCredits' className={`btn btn-primary ms-3`} onClick={() => navigate('/topup')}>
              Buy Credits
            </button>
          )}

          <button
            data-testid='btnExportCreditHistory'
            className={`btn btn-secondary ms-3`}
            onClick={exportData}
            disabled={isLoadingExport}
          >
            {isLoadingExport ? <Spinner /> : 'Exports'}
          </button>
        </div>
      </div>

      {userCreditHistory?.items?.length > 0 ? (
        <div className='card-body px-8 py-0'>
          <div className='table-responsive'>
            <table className='table align-middle gs-0 gy-5 credit_history_table'>
              <thead>
                <tr className='fw-bolder text-muted'>
                  <th>Date</th>
                  <th>Type</th>
                  <th>Description</th>
                  <th>Note</th>
                  <th>Credits</th>
                  {userData && userData.isSubClientAccount === true && <th>User</th>}
                  {isShowCredit && <th>Balance</th>}
                </tr>
              </thead>
              <tbody>
                {userCreditHistory?.items?.map((key: any, i: number) => (
                  <tr key={i}>
                    <td>
                      {moment(key?.createdAt).tz(userData?.timeZone).format('DD-MM-YYYY HH:mm:ss')}
                    </td>
                    <td className='table-row-gray-200'>
                      <span
                        className={
                          key?.type === 'sms'
                            ? 'badge badge-light-success green_text_badge badge-square p-4 w-50px py-5'
                            : 'badge badge-light-info fs-7 blue_text_badge badge-square p-4 w-50px py-5'
                        }
                      >
                        {key?.type?.toUpperCase()}
                      </span>
                    </td>
                    <td>{key?.description}</td>
                    <td>{key?.note}</td>
                    <td className='table-row-gray-200'>
                      <a
                        className={`badge  ${key?.status == 'debit' ? 'red_text_badge' : 'green_text_badge'
                          }  `}
                      >
                        {key?.status == 'debit' ? '-' : ''}
                        {key?.creditAmount.toFixed(1)}
                      </a>
                    </td>
                    {userData && userData.isSubClientAccount === true && (
                      <td>{key?.addedUser?.name || '-'}</td>
                    )}
                    {isShowCredit && <td>{key?.balance}</td>}
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
        </div>
      ) : (
        <NodataYet message={'No data yet'} />
      )}
      <div className='abcd px-8 pb-4'>
        <select
          value={page?.size}
          className='SelectSize'
          onChange={(e: any) => setPage({ ...page, size: e.target.value, page: 1 })}
        >
          <option value={10}>10</option>
          <option value={20}>20</option>
          <option value={50}>50</option>
          <option value={userCreditHistory?.total}>ALL</option>
        </select>
        <ReactPaginate
          previousLabel='<'
          nextLabel='>'
          pageCount={userCreditHistory?.totalPages}
          onPageChange={(e) => setPage({ ...page, page: e.selected + 1 })}
          containerClassName={'pagination'}
          previousLinkClassName={'pagination__link'}
          nextLinkClassName={'pagination__link'}
          disabledClassName={'pagination__link--disabled'}
          activeClassName={'pagination__link--active'}
        />
      </div>
    </div>
  )
}

export default CreditHistoryTable
